var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"Problems"},[_c('div',{staticClass:"problemList"},_vm._l((_vm.problemList),function(item){return _c('van-cell',{key:item.title,attrs:{"title":item.title,"is-link":""},on:{"click":function($event){return _vm.toDetail(item.id)}}})}),1)])
}
var staticRenderFns = []

export { render, staticRenderFns }